import { createFileRoute } from '@tanstack/react-router';
import MobileApps from '../../../administration/src/components/Apps/AppDetails/Installation/MobileApps';
import { withModalOutlet } from '../-withModalOutlet';

export const Route = createFileRoute('/_secured/administration/apps/$appId/installation/mobile-apps')({
  component: withModalOutlet(MobileApps),
});
